// Term spans for the archive timeline ribbon. Kept in its own (non-component)
// module so TimelineBarChart.tsx exports only its component — that keeps Vite
// fast-refresh working and the eslint react-refresh rule happy.

export interface TermBand {
  label: string;
  start: string; // "YYYY-MM" inclusive
  end: string; // "YYYY-MM" term-handoff month
}

// US presidential terms covering the archive era. Inaugurations are ~Jan 20;
// month granularity is plenty. Clipped to the visible range at draw time.
export const PRESIDENTIAL_TERMS: TermBand[] = [
  { label: "G.W. Bush", start: "2005-01", end: "2009-01" },
  { label: "Obama", start: "2009-01", end: "2017-01" },
  { label: "Trump", start: "2017-01", end: "2021-01" },
  { label: "Biden", start: "2021-01", end: "2025-01" },
  { label: "Trump", start: "2025-01", end: "2029-01" },
];
